import { ChevronDown } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import API from "../API/newIndex";
import Notification from "../Component/Notification";
import { InputComponent } from '@shopeasy-dashboard-ui/ui-library';
import TextareaComponent from "../Component/FormInput/TextareaComponent";

const UpdateCustomMetaField = ({ meta_fields, setmeta_fields, heading }) => {
  const [metaFieldData, setMetaFieldData] = useState([]);
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  const getMetaField = async () => {
    try {
      const ApiCall = await API({
        url: `/admin/metafieldgroup/getMetaFieldGroup/${heading}`,
        method: "get",
      });
      if (ApiCall.status === 200 || ApiCall.status === 304) {
        const result = ApiCall?.data;
        setMetaFieldData(result?.data?.custom_fields);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  useEffect(() => {
    getMetaField();
  }, []);

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      <details className="secondary-bg-color group shadow space-y-4 rounded-[6px] p-5 sm:p-[25px]">
        <summary
          htmlFor="Meta Tag Title"
          className="text-base w-full flex flex-col items-center font-medium "
        >
          <div className="flex w-full items-center justify-between">
            <div>
              <span>{t("lang_Custom_Field")}</span>
              <p className="text-xs table-text font-normal">{t("lang_Add_Custom_Field")}</p>
            </div>
            <span className="transition group-open:rotate-180">
              <ChevronDown className=" w-4 h-5" />
            </span>
          </div>
        </summary>
        <>
          {metaFieldData?.length > 0 &&
            metaFieldData?.map((elem, index) => {
              return (
                <div key={index} className="mb-4">
                  {elem.custom_field_type === "textarea" ? (
                    <TextareaComponent
                      label={elem.custom_field_name}
                      name={elem.custom_field_name}
                      value={meta_fields?.[elem.custom_field_name] || ""}
                      placeholder={elem.custom_field_name}
                      onChange={(e) =>
                        setmeta_fields({ ...meta_fields, [e.target.name]: e.target.value })
                      }
                    />
                  ) : elem.custom_field_type === "date" ? (
                    <div className="flex flex-col gap-1">
                      <label className="text-[var(--primary-text-color)] font-medium text-[13px] tracking-tight">
                        {elem.custom_field_name}
                      </label>
                      <ReactDatePicker
                        selected={meta_fields?.[elem.custom_field_name] ? moment(meta_fields[elem.custom_field_name]).toDate() : new Date()}
                        className="me-2 border table-text cursor-pointer focus:border-gray-400 border-gray-300 outline-none rounded-lg px-3 py-1.5 text-sm"
                        onChange={(date) =>
                          setmeta_fields({ ...meta_fields, [elem.custom_field_name]: date })
                        }
                        label="date"
                        dateFormat="dd-MM-yyyy"
                      />
                    </div>
                  ) : elem.custom_field_type === "date-time" ? (
                    <div className="flex flex-col gap-1">
                      <label className="text-[var(--primary-text-color)] font-medium text-[13px] tracking-tight">
                        {elem.custom_field_name}
                      </label>
                      <ReactDatePicker
                        selected={meta_fields?.[elem.custom_field_name] ? moment(meta_fields[elem.custom_field_name]).toDate() : new Date()}
                        showTimeSelect
                        className="me-2 border table-text cursor-pointer focus:border-gray-400 border-gray-300 outline-none rounded-lg px-3 py-1.5 text-sm"
                        onChange={(date) =>
                          setmeta_fields({ ...meta_fields, [elem.custom_field_name]: date })
                        }
                        label="date"
                        dateFormat="dd-MM-yyyy"
                      />
                    </div>
                  ) : (
                    <InputComponent
                      id={`custom-field-${index}`}
                      label={elem.custom_field_name}
                      name={elem.custom_field_name}
                      type={elem.custom_field_type}
                      placeholder={elem.custom_field_name}
                      value={meta_fields?.[elem.custom_field_name] || ""}
                      onChange={(e) =>
                        setmeta_fields({ ...meta_fields, [e.target.name]: e.target.value })
                      }
                    />
                  )}
                </div>
              );
            })}
        </>
      </details>
    </>
  );
};

export default UpdateCustomMetaField;
